/**
 * @generated SignedSource<<812fa07c74a77f868ddd9a3d69c19862>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Documents_component$data = {
  readonly files: {
    readonly brochure: {
      readonly " $fragmentSpreads": FragmentRefs<"FileLink_fileLink">;
    } | null | undefined;
    readonly factsheet: {
      readonly " $fragmentSpreads": FragmentRefs<"FileLink_fileLink">;
    } | null | undefined;
    readonly kid: {
      readonly " $fragmentSpreads": FragmentRefs<"FileLink_fileLink">;
    } | null | undefined;
    readonly others: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"FileLink_fileLink">;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly infolinks: ReadonlyArray<{
    readonly url: string;
    readonly " $fragmentSpreads": FragmentRefs<"InfoLink_infoLink">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "Documents_component";
};
export type Documents_component$key = {
  readonly " $data"?: Documents_component$data;
  readonly " $fragmentSpreads": FragmentRefs<"Documents_component">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "FileLink_fileLink"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "salesAdmission"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Documents_component",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "salesAdmission",
          "variableName": "salesAdmission"
        }
      ],
      "concreteType": "RecentTrancheDocuments",
      "kind": "LinkedField",
      "name": "files",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FileLink",
          "kind": "LinkedField",
          "name": "brochure",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FileLink",
          "kind": "LinkedField",
          "name": "factsheet",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FileLink",
          "kind": "LinkedField",
          "name": "kid",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FileLink",
          "kind": "LinkedField",
          "name": "others",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InfoLink",
      "kind": "LinkedField",
      "name": "infolinks",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "InfoLink_infoLink"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Documents",
  "abstractKey": null
};
})();

(node as any).hash = "072a9079d5f91e421edf03956b22d90c";

export default node;
